import React, { useState,useCallback  } from "react";
import styles from "./App.module.css";
import ListView from "./components/ListView";
import MapView from "./components/MapView";
import Header from "./components/Header";

function App() {
  const [filter, setFilter] = useState("");
  const [regionFilter, setRegionFilter] = useState(""); // 지역 필터 상태
  const [selectedPlace, setSelectedPlace] = useState(null); // 선택된 장소 저장

  const handlePlaceClick = useCallback((place) => {
    setSelectedPlace(place);
  }, []);


  return (
    <div className={styles.app}>
      <Header
        onChange={(value) => setFilter(value)}
        onRegionChange={(value) => setRegionFilter(value)} // 지역 필터 상태 업데이트
      />
      <div className={styles.splitView}>
        {/* ListView에 selectedPlace 전달 */}
        <ListView
          filter={filter}
          regionFilter={regionFilter}
          onPlaceClick={handlePlaceClick}
          selectedPlace={selectedPlace} // 선택된 장소 전달
        />
        <MapView
          filter={filter}
          regionFilter={regionFilter}
          selectedPlace={selectedPlace}
          onPlaceClick={handlePlaceClick} // MapView에서도 장소 선택 시 처리
        />
      </div>
    </div>
  );
}

export default App;
